<template>
  <div class="events-list">
    <div class="title-box primary-box">
      <div class="title-box__back-container">
        <v-icon @click="$router.push('/')">mdi-chevron-left</v-icon>
      </div>
      <div class="title-box__title">
        <h2 itemprop="headline">{{getTranslation('events-list')}}</h2>
      </div>
    </div>
    <div class="card-deck" id="events-deck">
      <template v-if="events.length > 0">
        <v-card
            class="card"
            v-for="ev in events"
            :key="ev.id"
            :id="ev.id"
        >
          <div @click="fullscreenImage = ev?.img?.formats?.large?.url">
            <v-img :src="ev?.img?.formats?.large?.url" :alt="ev?.img?.name" width="100%" eager>
            </v-img>
          </div>
        </v-card>
      </template>
      <template v-else>
        <h3 class="placeholder-message">
          Ancora nessun evento programmato, torna a visitarci per rimanere aggiornato sulle prossime programmazioni.
        </h3>
      </template>
    </div>

    <v-dialog v-model="showFullScreenImage" transition="dialog-bottom-transition">
      <v-img :src="fullscreenImage" style="max-width: 90vw; max-height: 90vh; object-fit: contain;"
             @click="fullscreenImage = null" eager></v-img>
    </v-dialog>
  </div>
</template>
<script>
import apiService from "@/services/ApiService";
import {getTranslation} from "@/services/stringTableService";

export default {
  name: 'EventsList',
  data() {
    return {
      events: [],
      language: "IT",
      fullscreenImage: null
    }
  },
  computed: {
    showFullScreenImage() {
      return this.fullscreenImage != null && window.innerWidth > 700;
    }
  },
  methods: {
    getTranslation(key) {
      return getTranslation(this.language, key);
    }
  },
  async beforeMount() {
    try {
      this.$store.dispatch('setLoading', false);
      const events = (await apiService.getEvents())
          .filter(ev => ev.expiration > new Date())
          .sort((a, b) => a.start - b.start);
      this.events = events;
    } catch (e) {
      console.error(e);
    } finally {
      this.$store.dispatch('setLoading', false);
    }
  }
}
</script>
<style scoped lang="scss">
@import "../style/_variables.scss";
.md-text-container-reseller {
  flex-direction: column;
  text-align: left;
  padding: 0px;
  gap: 10px;

  h2 {
    margin-top: 10px;
    font-family: $header-font;
  }
}
.events-list {
  text-align: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background-color: $secondary-background-color;
  font-family: $header-font;
  .card-deck {
    @media (max-width: 700px) {
      width: calc(100% - 32px);
    }
    .card {
      width: 350px;
      margin: 10px;
      border-radius: 0;
      background-color: transparent;
      box-shadow: none;
      @media (max-width: 700px) {
        width: 100%;
        margin: 5px;
        &:hover {
          transform: none;
        }
      }
    }
  }
}
.fullscreen-img {
  max-width: 100vw;
  max-height: 100vh;
  object-fit: contain;
}
</style>